import { render } from "./CardSliderPrev.vue?vue&type=template&id=aad39d6a"
import script from "./CardSliderPrev.vue?vue&type=script&lang=js"
export * from "./CardSliderPrev.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__